const AI_EXCLUDED_PLANS = new Set([
  "basic",
  "lite",
  "v1-basic-monthly",
  "v1-basic-yealry",
  "v1-basic-yearly",
]);

export function isAiEligiblePlan(planCode: unknown): boolean {
  return (
    typeof planCode === "string" &&
    planCode.trim().length > 0 &&
    !AI_EXCLUDED_PLANS.has(planCode.trim().toLowerCase())
  );
}
